import './_shared/styles/app.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LucideProvider } from 'lucide-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ThemeProvider } from '@/_shared/hooks/useTheme';
import { initAnalytics } from '@/_shared/lib/analytics';

import { App } from './App';

initAnalytics();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    {/* Default every lucide icon to a 1.5 stroke; per-icon strokeWidth props still win. */}
    <LucideProvider strokeWidth={1.5}>
      {/* defaultTheme must match the empty-storage fallback in index.html's pre-paint bootstrap. */}
      <ThemeProvider defaultTheme="light">
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ThemeProvider>
    </LucideProvider>
  </StrictMode>,
);
